import script from "./SupportCards.vue?vue&type=script&setup=true&lang=js"
export * from "./SupportCards.vue?vue&type=script&setup=true&lang=js"

import "./SupportCards.vue?vue&type=style&index=0&id=8ff6d2d2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/claims-portal/claims-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ff6d2d2"]])

export default __exports__